import React, {Fragment, useState} from 'react';

import {makeGetAdditionalCoverage} from 'main/factories/usecases';
import coverageImgSm from 'presentation/assets/images/additional-coverage-sm.webp';
import coverageImgLg from 'presentation/assets/images/additional-coverage-lg.webp';
import {IFrameModal} from 'presentation/components';
import {ModalError} from 'presentation/components/ModalError';
import {OperationStateTypesEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {PerksTaggingEnum} from 'main/analytics/gaTagsEnum';
import {PerksCard} from '../PerksCard';

const {additionalCoverageDescription, additionalCoverageTitle} =
	translations['pt-br'].privateFlow.perks;
const {additionalCoverage} = translations['pt-br'].privateFlow.services;
const {
	title: modalErrorTitle,
	subtitle,
	description,
	tryAgainBtn,
	backAction,
} = translations['pt-br'].others.genericErrorModal;

export function AdditionalCoverage() {
	const [urlState, setUrlState] = useState('');
	const [openIframeState, setOpenIframeState] = useState(false);
	const [operationState, setOperationState] = useState<OperationStateTypesEnum>(
		OperationStateTypesEnum.NONE,
	);

	const {isMobile} = useMediaQueries();
	const coverageImg = isMobile ? coverageImgSm : coverageImgLg;

	const IS_LOADING = operationState === OperationStateTypesEnum.SUBMITTING;
	const IS_ERROR = operationState === OperationStateTypesEnum.ERROR;

	const handleClick = async () => {
		try {
			setOperationState(OperationStateTypesEnum.SUBMITTING);
			const data = await makeGetAdditionalCoverage().get();
			setUrlState(data.url);
			setOpenIframeState(true);
			setOperationState(OperationStateTypesEnum.DONE);
		} catch (err) {
			setOperationState(OperationStateTypesEnum.ERROR);
		}
	};

	return (
		<Fragment>
			<PerksCard
				dataTagId={PerksTaggingEnum.CLICK_COBERTURAS_ADICIONAIS_BENEFICIOS}
				cardImage={coverageImg}
				description={additionalCoverageDescription}
				title={additionalCoverage}
				handleAction={handleClick}
				isLoading={IS_LOADING}
			/>
			{IS_ERROR ? (
				<ModalError
					open={IS_ERROR}
					onClose={() => setOperationState(OperationStateTypesEnum.NONE)}
					headerTitle={modalErrorTitle}
					title={subtitle}
					isFullScreen={false}
					maxWidth={420}
					description={description}
					firstButton={{
						title: backAction,
						handleClick: () => setOperationState(OperationStateTypesEnum.NONE),
						variant: 'outlined',
					}}
					secondButton={{
						title: tryAgainBtn,
						handleClick,
						variant: 'contained',
					}}
				/>
			) : null}

			<IFrameModal
				openIframe={openIframeState}
				setOpenIframe={setOpenIframeState}
				title={additionalCoverageTitle}
				url={urlState}
				handleBack={() => setOpenIframeState(false)}
			/>
		</Fragment>
	);
}
